module.exports = __webpack_public_path__ + "img/setting-profile.497fd610.svg";